// Inventory Status Types
const INVENTORY_STATUS_AVAILABLE = 1;
const INVENTORY_STATUS_NEARING_CAPACITY = 2;
const INVENTORY_STATUS_UNAVAILABLE = 3;
const INVENTORY_STATUS_SOLDOUT = 4;

export default {
  INVENTORY_STATUS_AVAILABLE: INVENTORY_STATUS_AVAILABLE,
  INVENTORY_STATUS_NEARING_CAPACITY: INVENTORY_STATUS_NEARING_CAPACITY,
  INVENTORY_STATUS_UNAVAILABLE: INVENTORY_STATUS_UNAVAILABLE,
  INVENTORY_STATUS_SOLDOUT: INVENTORY_STATUS_SOLDOUT
}